// 对外提供列表组件、支持滚动、点击后自动滚动到最顶部、向外传递选中的值
import styled from '@emotion/styled'
import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react'

const StyledList = styled('div')`
  flex: 1;
  text-align: center;
  overflow: scroll;
  .time-item {
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background: #ebeef2;
    }
  }
  .active {
    background: var(--ow-color-primary-600);
    color: #fff;
    &:hover {
      background: var(--ow-color-primary-600);
    }
  }
`

const TypeMap = {
  hour: 24,
  minute: 60,
}

const formatTime = (num) => (num <= 9 ? `0${num}` : `${num}`)

const TimeList = forwardRef(
  ({ type = 'hour', defaultVal = '00', onSelectTimeItem }, ref) => {
    const [activeIndex, setActiveIndex] = useState()
    const listRef = useRef()
    const clickHandler = (event, index) => {
      try {
        const val = formatTime(index)
        // offsetHeight 获取的值为整数，略大于实际高度，导致设置 scrollTop 后显示异常
        const itemHeight = event.target
          .getBoundingClientRect()
          .height.toFixed(3)
        listRef.current.scrollTop = itemHeight * val
        setActiveIndex(index)
        onSelectTimeItem({ type, val })
      } catch (err) {
        console.log(err)
      }
    }

    useImperativeHandle(ref, () => ({
      reset() {
        setActiveIndex('')
        listRef.current.scrollTop = 10000
      },
    }))
    return (
      <StyledList ref={listRef}>
        {new Array(TypeMap[type]).fill(0).map((item, index) => {
          const content = formatTime(index)
          return (
            <div
              className={
                activeIndex === index || defaultVal === content
                  ? 'active time-item'
                  : 'time-item'
              }
              key={`time-${type}-${index}`}
              onClick={(e) => clickHandler(e, index)}
            >
              {content}
            </div>
          )
        })}
      </StyledList>
    )
  }
)

export default TimeList
